export const TranslationValues = {
	siteName: 'Information',
	listName: 'ECommerceResources',
	keyGroups: {
		global: 'global',
	},
};
